import { alpha, darken } from '@mui/material/styles';

export function buildCardInfoContentHorizontalPalette({ mode, brandMain, palette }) {
  const baseRow = mode === 'dark'
    ? alpha('#ffffff', 0.06)
    : alpha(brandMain, 0.08);

  return {
    headerBg: mode === 'dark' ? darken(brandMain, 0.2) : brandMain,
    headerText: '#ffffff',
    icon: '#ffffff',
    bg: palette.background.paper,
    contentText: palette.text.primary,
    border: mode === 'dark' ? alpha('#ffffff', 0.15) : alpha('#000000', 0.08),
    shadow: mode === 'dark'
      ? '0 16px 40px rgba(0,0,0,0.6)'
      : '0 12px 32px rgba(128,0,0,0.2)',
    rowBg: baseRow,
    rowShadow: mode === 'dark'
      ? '0 4px 12px rgba(0,0,0,0.35)'
      : '0 6px 18px rgba(0,0,0,0.08)',
  };
}
